import { useMemo } from 'react';

export interface AgentRandomSortMap {
  [id: string]: number;
}

export const useAgentSort = <
  T extends { sys: { id: string }; active?: boolean | null },
>({
  agents,
  agentRandomSortOrder,
}: {
  agents?: T[];
  agentRandomSortOrder: AgentRandomSortMap;
}) =>
  useMemo(
    () => agentSort({ agents, agentRandomSortOrder }),
    [agents, agentRandomSortOrder],
  );

export const agentSort = <
  T extends { sys: { id: string }; active?: boolean | null },
>({
  agents,
  agentRandomSortOrder,
}: {
  agents?: T[];
  agentRandomSortOrder: AgentRandomSortMap;
}) => {
  if (!agents) {
    return agents;
  }
  // Primary sort is active agents on top, secondary sort is random order generated server-side
  return [...agents].sort((a, b) =>
    a.active && !b.active
      ? -1
      : !a.active && b.active
      ? 1
      : agentRandomSortOrder[a.sys.id] - agentRandomSortOrder[b.sys.id],
  );
};

export const generateAgentRandomSortOrder = <
  T extends { sys: { id: string }; active?: boolean | null },
>(
  agents: T[],
) =>
  agents.reduce<AgentRandomSortMap>(
    (acc, agent) => ({ ...acc, [agent.sys.id]: Math.random() }),
    {},
  );
